import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StepGuideComponent } from './step-guide.component';

const routes: Routes = [{ path: '', component: StepGuideComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StepGuideRoutingModule { }
